import { Alert, Card, Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useShouldCompleteProfile } from '../../../user/utils';
import { AnimatedBox } from '../animated-box';

export const Banners = () => {
  const { t } = useTranslation('common');
  const isProfileIncomplete = useShouldCompleteProfile();

  return (
    <Stack gap={2}>
      {isProfileIncomplete && (
        <AnimatedBox animation="fadeInDown">
          <Card.Root
            css={{
              borderRadius: 12,
              overflow: 'hidden',
              border: '1px solid',
              borderColor: 'red.100',
            }}
          >
            <Card.Body p={1}>
              <Alert.Root status="error" rounded="lg">
                <Alert.Indicator />
                <Alert.Content>
                  <Alert.Title>{t('alert.completeProfile')}</Alert.Title>
                </Alert.Content>
              </Alert.Root>
            </Card.Body>
          </Card.Root>
        </AnimatedBox>
      )}
    </Stack>
  );
};
